;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.NotificationBanner = Backbone.Model.extend({
		defaults: {
			"show": 0,
			"text": "",
		},
		methodUrl: 'banner.json',
		url: function() {
			$.ajaxQ.preventAbort();
			return this.methodUrl;
		},
		get_banner: function() {
			$.ajaxQ.preventAbort();
			return this.setApiUrl('banner.json').fetch({ is_project_json: true })
		},

		isNew: function() {
			return true;
		},
	});

}(window, APP, Backbone, Marionette, $, _));